// src/data/m2/index.js

import { M2_UNIT_1 } from './Unit1';
import { M2_UNIT_2 } from './Unit2';
import { M2_UNIT_3 } from './Unit3';
import { M2_UNIT_4 } from './Unit4';
import { M2_UNIT_5 } from './Unit5';
import { M2_UNIT_6 } from './Unit6';
import { M2_UNIT_7 } from './Unit7';
import { M2_UNIT_8 } from './Unit8';
import { M2_UNIT_9 } from './Unit9';
import { M2_UNIT_10 } from './Unit10';
import { M2_UNIT_11 } from './Unit11';
import { M2_UNIT_12 } from './Unit12';
import { M2_UNIT_13 } from './Unit13';
import { M2_UNIT_14 } from './Unit14';
import { M2_UNIT_15 } from './Unit15';
import { M2_UNIT_16 } from './Unit16';
import { M2_READING } from './ReadingPractice';
import { M2_UNIT_REVIEW } from './UnitReview';

export const MODULE_2_UNITS = [
  M2_UNIT_1,
  M2_UNIT_2,
  M2_UNIT_3,
  M2_UNIT_4,
  M2_UNIT_5,
  M2_UNIT_6,
  M2_UNIT_7,
  M2_UNIT_8,
  M2_UNIT_9,
  M2_UNIT_10,
  M2_UNIT_11,
  M2_UNIT_12,
  M2_UNIT_13,
  M2_UNIT_14,
  M2_UNIT_15,
  M2_UNIT_16,
  M2_READING,
  M2_UNIT_REVIEW
];